export class Translator {
    constructor(assistent) {
        this.assistent = assistent;

        /** Elements */
        this.translatorResponse = this.assistent.stepElements.translator_response;
        this.translatedFieldsWrapper = this.translatorResponse.querySelector('.compass-assistent-response-fields');
    }

    originLanguage = null;
    targetLanguages = null;
    fields = null;
    translatedFieldValues = {};
    targetFields = {};

    /**
     * Methods
     * */
    handleTranslationAction(originLanguage, targetLanguages, fields, targetFields) {
        this.assistent.actionChoice = this.assistent.actionChoices.translator;

        this.targetFields = targetFields;
        this.originLanguage = originLanguage;
        this.targetLanguages = targetLanguages;
        this.fields = fields;

        // check if originLanguage is an array
        if (!Array.isArray(targetLanguages)) {
            targetLanguages = [targetLanguages];
        }

        let fieldValues = {};

        for (const [key, value] of Object.entries(fields)) {
            if (value.ckeditor) {
                value.value = value.ckeditor.getData();
            }

            fieldValues[key] = value.value;
        }

        const data = {
            target_language: targetLanguages,
            origin_language: originLanguage,
            fields: fieldValues,
        }

        if (!this.assistent.isVisible()) {
            this.assistent.classList.remove('d-none');
        }
        this.assistent.setActiveStep(this.assistent.stepElements.processing);

        const responseData = this.assistent.requests.post(this.assistent.configuration.routes.translator, data).then(async response => {
            const data = await response.json();
            this.translatedFieldValues = data.fields;

            // empty the response fields
            this.translatedFieldsWrapper.innerHTML = '';

            for (const [key, field] of Object.entries(fields)) {
                const translatedValue = data.fields[key];
                // find .form-group parent without jquery
                let formGroup = field;
                while (formGroup && !formGroup.classList.contains('form-group')) {
                    formGroup = formGroup.parentElement;
                }
                // clone field and set the value
                let responseField = formGroup.cloneNode(true);

                if (field.type === 'textarea') {
                    const newField = responseField.querySelector('[name="' + field.name + '"]');
                    newField.innerHTML = translatedValue;
                    newField.value = translatedValue;

                    if (field.ckeditor) {
                        newField.classList.remove('ckeditor-initialised');
                        newField.parentElement.querySelector('.ck.ck-editor').remove();
                    }
                } else {
                    responseField.querySelector('[name="' + field.name + '"]').value = translatedValue;
                }


                this.translatedFieldsWrapper.appendChild(responseField);
                window.loadMarkdownCkeditor();
                window.loadSimpleCkeditor();
                window.loadAdvancedCkeditor();
            }
            this.assistent.setActiveStep(this.assistent.stepElements.translator_response);
        }).catch(error => {
            window.Sentry?.captureException(error);
            // dump in console if .local or .test domain
            if (window.location.hostname.includes('.local') || window.location.hostname.includes('.test')) {
                console.error(error);
            }
        });
    }

    retryTranslation() {
        this.handleTranslationAction(this.originLanguage, this.targetLanguages, this.fields, this.targetFields);
    }

    useTranslation() {
        for (let [key, value] of Object.entries(this.translatedFieldValues)) {
            // check if the key is in the translatedField
            if (!this.targetFields[key]) {
                continue;
            }

            const fieldName =  this.fields[key].name;
            const translatedField = this.translatedFieldsWrapper.querySelector('[name="' + fieldName + '"]');

            if (translatedField.ckeditor) {
                value = translatedField.ckeditor.getData();
            } else {
                value = translatedField.value;
            }

            const field = this.targetFields[key];
            if (field.ckeditor) {
                field.ckeditor.setData(value);
                field.innerHTML = value;
                continue;
            }

            field.value = value;
        }

        this.assistent.close();
    }
}
